/**
 * @generated SignedSource<<517acfc0b365d86ef86c892675953b8f>>
 * @relayHash e8ab1aa41f56a8e58f4647aa87445304
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 44d71eb1075e55c9e8988db704ccfc0b6109617afe7632d2d7fe5937068a9f7a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type fetchPresenceAGGUsersQuery$variables = {
  accountIds: ReadonlyArray<string>;
};
export type fetchPresenceAGGUsersQuery$data = {
  readonly users: ReadonlyArray<{
    readonly accountId: string;
    readonly id: string;
    readonly name: string;
    readonly picture: AGG$URL;
  }> | null | undefined;
};
export type fetchPresenceAGGUsersQuery = {
  response: fetchPresenceAGGUsersQuery$data;
  variables: fetchPresenceAGGUsersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountIds",
    "variableName": "accountIds"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "picture"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "fetchPresenceAGGUsersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "fetchPresenceAGGUsersQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "users",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e8ab1aa41f56a8e58f4647aa87445304",
    "id": "44d71eb1075e55c9e8988db704ccfc0b6109617afe7632d2d7fe5937068a9f7a",
    "metadata": {},
    "name": "fetchPresenceAGGUsersQuery",
    "operationKind": "query",
    "text": "query fetchPresenceAGGUsersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){__typename,accountId,name,picture,id}}"
  }
};
})();

(node as any).hash = "57d1e29c802c13d5478283a266661ce1";

export default node;
